import React from 'react';
import {
  IconButton,
  Tooltip,
  Typography,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import {useTranslation} from 'react-i18next';

interface RefreshButtonProps {
  label: string;
  onClick: () => void;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({label, onClick}) => {
  const {t} = useTranslation();

  const theme = useTheme();
  const biggerScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Tooltip title={t(label)}>
      <Box
        display="flex"
        alignItems="center"
        onClick={onClick}
        sx={{cursor: 'pointer', marginRight: 1.5}}
      >
        <IconButton>
          <RefreshIcon />
        </IconButton>
        <Typography variant={biggerScreen ? 'subtitle1' : 'subtitle2'}>
          {t(label)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default RefreshButton;
